import { faro } from '@gate31/faro/src';
import { FirstVisit } from '../FirstVisit/FirstVisit';

export class Admitad {
    // https://support.admitad.ru/knowledge-base/article/%D0%B8%D0%BD%D1%82%D0%B5%D0%B3%D1%80%D0%B0%D1%86%D0%B8%D1%8F-%D1%87%D0%B5%D1%80%D0%B5%D0%B7-postback-%D0%B7%D0%B0%D0%BF%D1%80%D0%BE%D1%81_1#how-to-set-admitad_uid-in-cookies
    static daysToStore = 90;

    // Параметр ссылки в котором лежим uid из адмитада
    static uidParamName = 'admitad_uid'

    // Кука с uid пользователя/рекламы/источника адмитад
    static uidCookieName = 'admitad_uid'

    // https://shop-64875-43.myinsales.ru/admin2/fields/8424683/edit?destiny=3
    static insalesUidFieldId = 8424683
    static insalesIsNewFieldId = 93598409

    constructor() {}

    private static getParamFromUrl(paramName: string) {
        const regex = new RegExp('[?&]' + paramName + '=([^&#]*)');
        const results = regex.exec(window.location.search);

        return results ? decodeURIComponent(results[1].replace(/\+/g, ' ')) : '';
    }

    private static setCookie(name: string, value: string, days: number) {
        const expires = new Date(Date.now() + days * 864e5).toUTCString();
        const cookieBase = `${name}=${value}; path=/; expires=${expires}; SameSite=Lax`;

        // Установка cookie для текущего домена
        document.cookie = cookieBase;
    }

    private static getCookie(name: string): string | null {
        const nameEQ = `${name}=`;
        const cookies = document.cookie.split(';');

        for (let i = 0; i < cookies.length; i++) {
            const c = cookies[i].trim();

            if (c.startsWith(nameEQ)) {
                return decodeURIComponent(c.substring(nameEQ.length));
            }
        }

        return null;
    }

    // Клиент старый толко если первый визит был раньше чем первый визит от адмитада
    static isNewClient(): false | undefined {
        const firstFisitTime = this.getCookie(FirstVisit.mainValue);
        const firstAdmitadFisitTime = this.getCookie(FirstVisit.admitadValue);

        if (! firstFisitTime && ! firstFisitTime) {
            return;
        }

        if (! firstFisitTime && firstAdmitadFisitTime) {
            return;
        }

        if (firstFisitTime && ! firstAdmitadFisitTime) {
            return;
        }

        if (firstFisitTime && firstAdmitadFisitTime) {
            return new Date(firstFisitTime) > new Date(firstAdmitadFisitTime) ? undefined : false;
        }
    }

    // Для каждой страницы магазина
    static setAdmitadCookie() {
        FirstVisit.setMainValues();
        FirstVisit.setAdmitadValues();

        const uid = Admitad.getParamFromUrl(Admitad.uidParamName);

        if (! uid) return;

        Admitad.setCookie(Admitad.uidCookieName, uid, Admitad.daysToStore);
    }

    static getInsalesField(id: number) {
        return document.querySelector<HTMLInputElement>(`[name="order[fields_values_attributes][${id}][value]"]`);
    }

    static setIsNewClientFormInsalesField() {
        const isNewClient = Admitad.isNewClient();

        // Получить поле
        const currentField = Admitad.getInsalesField(Admitad.insalesIsNewFieldId);

        if (! currentField) {
            faro.api.pushError(new Error('Not fund admitad field on chackout page'), {
                context: {
                    section: 'ADMITAD'
                }
            });

            return;
        }

        // Записываем значение
        currentField.value = String(isNewClient);
    }

    // Для страница оформления заказа
    static setUidFromInsalesField() {
        const uidValue = Admitad.getCookie(Admitad.uidCookieName);

        if (! uidValue) return;

        // Получить поле
        const currentField = Admitad.getInsalesField(Admitad.insalesUidFieldId);

        if (! currentField) {
            faro.api.pushError(new Error('Not fund admitad field on chackout page'), {
                context: {
                    section: 'ADMITAD'
                }
            });

            return;
        }

        // Записываем значение
        currentField.value = uidValue;
    }
}
